import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions';
import { AUTHORIZATION } from '../../../constants/endpoints';
import { postAPI } from '../../../api/apiConfig';
import { requestTokenVerification } from '../actions/verifyTokenActions';
import { SIGN_IN_REQUEST } from '../constants';
import { TOKEN, USERNAME } from '../../../constants/localStorage';
export function* callLoginUser({ credentials }) {
    const body = {
        password: credentials.password,
        username: credentials.username,
    };
    try {
        const token = yield call(postAPI, AUTHORIZATION, body);
        yield put(actions.receiveSignIn({ token: token.token }));
        window.localStorage.setItem(USERNAME, credentials.username);
        yield put(requestTokenVerification({
            token: localStorage.getItem(TOKEN),
        }));
    }
    catch (error) {
        yield put(actions.errorSignIn({
            errorMessage: `No customer found. ${error.message}`,
        }));
    }
}
export default [takeLatest(SIGN_IN_REQUEST, callLoginUser)];
